// test874
(874 && 0);
